import React from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../logo.svg";
import { Navbar, Button, Container, Nav } from "react-bootstrap";

const BarraNavegacion = () => {
    const initialDim = 60;
    const [logoDim, setLogoDim] = React.useState(initialDim);
    const [clases, setClases] = React.useState("barra");
    const navigate = useNavigate();

    React.useEffect(() => {
        const handleScroll = () => {
            const currentScrollPos = window.scrollY;
            if (currentScrollPos >= 10) {
                setLogoDim(30);
                setClases("barra_scrolled");
            } else {
                setLogoDim(initialDim);
                setClases("barra");
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const handleNavClick = (sectionId) => {
        navigate('/');
        setTimeout(() => {
            const section = document.querySelector(sectionId);
            if (section) {
                section.scrollIntoView({ behavior: 'smooth' });
            }
        }, 100);
    };

    return (
        <Navbar className={`${clases}`} fixed="top" expand="lg" data-bs-theme="dark">
            <Container fluid>
                <Navbar.Brand as={Link} to="/">
                    <img
                        alt=""
                        src={logo}
                        width={logoDim}
                        height={logoDim}
                        className="d-inline-block align-top"
                    />
                </Navbar.Brand>
                {/* Añadir aria-controls para asociar el botón de toggle con el Collapse */}
                <Navbar.Toggle aria-controls="navbar-content" />
                <Navbar.Collapse id="navbar-content" className="justify-content-end">
                    <Nav>
                        <Nav.Link onClick={() => handleNavClick('#home')}>Inicio</Nav.Link>
                        <Nav.Link onClick={() => handleNavClick('#whatwedo')}>¿Qué hacemos?</Nav.Link>
                        <Nav.Link onClick={() => handleNavClick('#nuestroservicio')}>Nuestro Servicio</Nav.Link>
                        <Nav.Link onClick={() => handleNavClick('#ourclients')}>Clientes</Nav.Link>
                        <Nav.Link onClick={() => handleNavClick('#contactus')}>Contacto</Nav.Link>
                        <Nav.Link onClick={() => handleNavClick('#noticias')}>Noticias</Nav.Link>
                        <Button className="btn-login" href="https://consultores.sereslatam.com">Consultores</Button>
                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default BarraNavegacion;
